import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { editor } from '@/instance';

export interface IUserInfoParams {
    id: number;
    avatar: string;
    screen_name: string;
    is_vip?: boolean;
    /** 会员阶段，透传给美豆面板 */
    stage?: number;
    vip_end_time?: number;
    email?: string;
}

export interface IUserInfoModel {
    userInfo: null | IUserInfoParams;
    setUserInfo: (payload: IUserInfoParams) => void;
    getUserInfo: () => IUserInfoParams | null;
    destroy: () => void;
}

const useUserInfoModel = create<IUserInfoModel>()(
    immer((set, get) => ({
        /** 当前用户信息 */
        userInfo: null,
        /** 更新用户信息 */
        setUserInfo: (payload) =>
            set((state) => {
                state.userInfo = payload;
                editor.setUid(payload.id);
            }),
        getUserInfo: () => get().userInfo,
        destroy: () =>
            set((state) => {
                state.userInfo = null;
                editor.setUid(0);
            }),
    })),
);

export { useUserInfoModel };
export const getUserInfoModel = () => useUserInfoModel.getState();
